import React, { useContext, useEffect, useState } from 'react';
import { convertFilterToQueryString, getInitialTransactionsFilters } from '../../../../flows/transactions/utils';
import { useGetLatestTrxQuery } from '../../Hooks/useGetLatestTrxQuery';
import LatestTransactions from '../../../../generic-components/LatestTransactions';
import { FlowContext } from '../../context';
import { STEPS } from '../../consts';

export const LatestTransactionsWrapper = () => {
  const qParams = convertFilterToQueryString(getInitialTransactionsFilters());
  const { data, isLoading } = useGetLatestTrxQuery({ q: qParams });
  const context = useContext(FlowContext);
  const [trxData, setTrxData] = useState([]);

  const handleShowAll = () => {
    context.changeActiveStep(STEPS.TRANSACTIONS);
  };

  useEffect(() => {
    if (data) {
      setTrxData(data);
    }
    return () => {
      setTrxData([]);
    };
  }, [data]);

  return (
    <div className='absolute inset-0'>
      <div className='flex flex-col h-full overflow-y-auto'>
        <LatestTransactions handleShowAll={handleShowAll} data={trxData} isLoading={isLoading} navPath='' />
      </div>
    </div>
  );
};
